import { AxiosResponse } from 'axios';

export class NotSufficientWebcoinsError extends Error {
  constructor() {
    super('not sufficient webcoins');
  }

  static isNotSufficientWebcoins(apiResponse: AxiosResponse) {
    return apiResponse.data?.data?.message === 'not.enough.web.coins';
  }
}

export class UnknownError extends Error {}
